import { render, staticRenderFns } from "./ZaloOtpBlock.vue?vue&type=template&id=683f375b&"
import script from "./ZaloOtpBlock.vue?vue&type=script&lang=js&"
export * from "./ZaloOtpBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports